import { useEffect, useState } from 'react';
import { Helmet } from "react-helmet-async";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '../../components/general/Banner';
import Celikler from '../../components/general/Celikler';
import { fetchPageGetSlug } from '../../redux/slices/pageGetSlugSlice';
import { fetchSeoGet } from '../../redux/slices/seoGetSlice';

const WagesPage = () => {
    const page = useSelector((state) => state.pageGetSlug.data);
    const lang = useSelector((state) => state.lang.lang);
    const seo = useSelector((state) => state.seoGet.data);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const getData = async () => {
        setLoading(true)
        await dispatch(fetchPageGetSlug({ slug: "ucretler" }));
        await dispatch(fetchSeoGet({ slug: "ucretler" }));
        setLoading(false)
    }

    useEffect(() => { getData() }, [])

    return (
        !loading ? <Celikler>
            {seo && seo.title && seo.description && (
                <Helmet>
                    <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
                    <meta name="description" content={seo.description?.[lang] || ""} />
                    <meta name="keywords" content={seo.keywords?.[lang] || ""} />
                    <meta name="robots" content="index, follow" />
                    <link rel="canonical" href={window.location.href} />
                </Helmet>
            )}
            <Banner title={page?.title[lang]} />
            <div className='container mt-5 w-100 d-flex justify-content-center'>
                <div className='prices'>
                    <div className='first-row'>
                        <div className='item item-1'>{t("socket_type")}</div>
                        {
                            (page?.showcases[0]?.modules ? [...page?.showcases[0]?.modules] : [])
                                .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                                .map((item, index) => {
                                    return (
                                        <div className='item' key={index}>{item?.title[lang]}</div>
                                    )
                                })
                        }
                    </div>
                    <div className='second-row'>
                        <div className='item item-1'>{t("strength")}</div>
                        {
                            (page?.showcases[0]?.modules ? [...page?.showcases[0]?.modules] : [])
                                .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                                .map((item, index) => {
                                    return (
                                        <div className='item' key={index}>{item?.description[lang]}</div>
                                    )
                                })
                        }
                    </div>
                    <div className='third-row'>
                        <div className='item item-1'>{t("price")}</div>
                        {
                            (page?.showcases[0]?.modules ? [...page?.showcases[0]?.modules] : [])
                                .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                                .map((item, index) => {
                                    return (
                                        <div className='item' key={index}>{item?.specialField1[lang]}</div>
                                    )
                                })
                        }
                    </div>
                </div>
            </div>
            <div className='text-center'>
                <div className='item item-1'>{page?.showcases[0]?.description[lang]}</div>
                <div className='item' dangerouslySetInnerHTML={{ __html: page?.showcases[0]?.content[lang] }}></div>
            </div>

        </Celikler> : <div className="modern-spinner-wrapper">
            <div className="modern-spinner"></div>
        </div>
    )
}

export default WagesPage
